import styled from 'styled-components';

export const VirtualOfficeSubscriptionStyled = styled.div`
  cursor: pointer;
  background: ${(props) => props.theme.colors.neutral100};
  border-radius: 15px;
  padding: 20px;
  width: 100%;
  min-height: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

export const PromotionBanner = styled.div`
  padding: 6px 24px;
  border-radius: 4px;
  background: linear-gradient(90deg, #dbbb7b 0%, #a17c56 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
`;
